import "../styles/Footer.css";
import logo from "../assets/img/logo.png";
import {FaLinkedin, FaInstagram} from "react-icons/fa";
import {MdEmail, MdLocationOn, MdPhone} from "react-icons/md";

export default function Footer() {
    const year = new Date().getFullYear();

    const openCookiePreferences = () => {
        const event = new CustomEvent("open-cookie-preferences");
        window.dispatchEvent(event);
    };

    return (
        <footer className="gl-footer">
            <div className="gl-footer__container">
                <div className="gl-footer__left">
                    <a href="/" className="gl-footer__logo">
                        <div className="gl-footer__logo-wrap">
                            <img src={logo} alt="GL — Giammarco Lamanda"/>
                        </div>
                    </a>

                    <div className="gl-footer__socials" aria-label="Social">
                        <a href="mailto:lamanda.nutrizionista@gmail.com" aria-label="Email" className="gl-social-btn">
                            <MdEmail size={20}/>
                        </a>
                        <a href="https://www.instagram.com/thefueldoctor/" aria-label="Instagram"
                           className="gl-social-btn">
                            <FaInstagram size={20}/>
                        </a>
                        <a href="https://www.linkedin.com/in/giammarco-lamanda-a9323a178/" aria-label="LinkedIn"
                           className="gl-social-btn">
                            <FaLinkedin size={20}/>
                        </a>
                        <a href="tel:+393792069823" aria-label="Phone" className="gl-social-btn">
                            <MdPhone size={20}/>
                        </a>
                    </div>
                </div>

                <div className="gl-footer__right">
                    <ul className="gl-footer__locations">
                        <li className="loc-item">
                            <MdLocationOn className="pin" aria-hidden/>
                            <span className="loc-text">
                                <strong>Roma</strong> - Circonvallazione Gianicolense, 78
                            </span>
                        </li>
                        <li className="loc-item">
                            <MdLocationOn className="pin" aria-hidden/>
                            <span className="loc-text">
                                <strong>Guglionesi (CB)</strong> - Via Giuseppe Manente, 3
                            </span>
                        </li>
                        <li className="loc-item">
                            <MdLocationOn className="pin" aria-hidden/>
                            <span className="loc-text">
                                <strong>Online</strong>
                            </span>
                        </li>
                    </ul>
                </div>
            </div>

            <div className="gl-footer__copy">
    <span className="copy-text">
        © {year} GL — Giammarco Lamanda. Tutti i diritti riservati.
    </span>
                <button
                    className="cookie-link"
                    onClick={openCookiePreferences}
                >
                    Gestisci preferenze cookie
                </button>
            </div>

        </footer>
    );
}
